// extracted by mini-css-extract-plugin
export default {"pageTitle":"DemoLimitedAccess_pageTitle__C1lqO","optionsContainer":"DemoLimitedAccess_optionsContainer__hUUuC","optionsContent":"DemoLimitedAccess_optionsContent__HQz3N"};